import React from "react";
import { Header } from "./Introduce";
import test_detail_style from "../css/test_detail_style.css";

class Share extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 1,
    };
  }

  render() {
    return (
      <div>
        <Header text="分享实验室"></Header>

        <div className={test_detail_style.share_photo}>
          <img src={require("../static/share.jpg")} alt="" />
        </div>
        <p>点击图片保存二维码</p>
      </div>
    );
  }
}

export default Share;



// WEBPACK FOOTER //
// ./src/pages/share.js